module.exports = __webpack_public_path__ + "static/img/9.daa86ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/eng/9.png
// module id = D0Fe
// module chunks = 0